import { Head } from 'arcway/lib/client';
import { LegalDocument } from '#components/legal-document.jsx';
export default function PrivacyPage({
  document
}) {
  return <>
      <Head description='How mono.fm collects, uses, and protects personal data.' title='Privacy Policy — mono.fm' />
      <LegalDocument document={document} otherHref='/legal/terms' otherTitle='Terms of Service' />
    </>;
}